// extracted by mini-css-extract-plugin
module.exports = {"root":"index_root__-xRfv"};